<template>
  <v-card>
    <v-card-text class="row">
      <v-col cols="12">
        <v-select
          label="Основание перезапуска"
          hide-details
          dense
          v-model="stopReason"
          :items="items"
          outlined
        ></v-select>
      </v-col>
      <v-col cols="12" v-if="stopReason === null">
        <span class="text-overline">Доп. варианты</span>
        <v-checkbox
          v-model="selectedOptions['ORCHESTRATOR_PASSPORTS_RESET']"
          label="С удалением состояний паспортов в оркестраторе"
          hide-details
          dense
        ></v-checkbox>
      </v-col>

      <v-col cols="12">
        <span class="text-overline">Удаление прикрепленных вложений</span>

        <v-checkbox
          v-model="selectedOptions['ATTACHMENTS_PERSONS_CLEAN']"
          label="Удалить загруженные паспорта физ. лиц"
          hide-details="auto"
          dense
        ></v-checkbox>

        <v-checkbox
          v-model="selectedOptions['ATTACHMENTS_APP_CLEAN']"
          label="Удалить загруженные документы"
          hide-details="auto"
          hint="Обычно загружаемые на встречах"
          persistent-hint
          dense
          @change="onChangeAttachmentsMeetingClean"
        ></v-checkbox>

        <v-slide-x-transition v-if="attachmentsDocuments" origin="left 0" mode="in-out">
          <div v-if="attachmentMeetingCleanSelected" class="ml-4 my-2">
            <span class="text-subtitle-2">Типы удаляемых документов</span>
            <v-chip-group
              v-model="selectedOptions['ATTACHMENTS_TYPES_APP_CLEAN']"
              color="accent darken-3"
              multiple
              column
              @change="onChangeAttachmentsTypesMeetingClean"
            >
              <v-chip
                v-for="[name, title] in attachmentsDocuments"
                :key="`attachmentDocument-${name}`"
                :value="name"
                :title="title"
                filter
                small
              >{{ title }}</v-chip>
            </v-chip-group>
          </div>
        </v-slide-x-transition>
      </v-col>

      <v-col cols="12">
        <v-divider />

        <v-checkbox
          v-model="restartAgree"
          label="После подтверждения процесс обработки заявки будет сброшен и начат заново. Вы уверены?"
          hide-details
          dense
        ></v-checkbox>
      </v-col>
    </v-card-text>
    <v-card-actions class="justify-end pt-1">
      <v-btn
        color="warning"
        :disabled="stopReason === undefined || !restartAgree"
        @click="restart"
        :elevation="0"
      >Перезапустить</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

const defaultSelectedOptions = {
  'ATTACHMENTS_PERSONS_CLEAN': true,
  'ATTACHMENTS_APP_CLEAN': true,
};

export default {
  name: "AppRestart",

  data() {
    return {
      restartAgree: false,

      stopReason: undefined,
      selectedOptions: Object.assign({}, defaultSelectedOptions),
      items: [ // FIXME: брать с сервера
        { header: 'Тип перезапуска', divider: true },
        { text: "Стандартный процесс", value: null },
        { text: "Недействительные представители и/или реквизиты организации", value: "invalid_company_data" },

        { header: 'Отказные причины', divider: true },
        { text: "Отказ - Компания не является действующей", value: "decline_inactive_company" }
      ],
    };
  },

  computed: {
    attachmentMeetingCleanSelected() {
      return this.selectedOptions['ATTACHMENTS_APP_CLEAN'] === true;
    },

    attachmentsDocuments() {
      const notUniqueDocumentsList = this.$store.getters['app/attachments']?.flatMap((attachmentGroup) => {
        return attachmentGroup.list.map((attachmentDocument) => [attachmentDocument.name, attachmentDocument.title]);
      });

      if (!notUniqueDocumentsList?.length) return null;

      return new Map(notUniqueDocumentsList.values());
    }
  },

  beforeMount() {
    if (process.env.NODE_ENV === 'development') {
      const testItems = [
        { text: "Отказ-Отказ есть записи о блокировках", value: "Отказ-Отказ есть записи о блокировках" },
        {
          text: "Отказ - ФЛ паспорт найден в массиве недействительных паспортов",
          value: "Отказ-ФЛ паспорт найден в массиве недействительных паспортов",
        },
        {
          text: "Отказ - Отсутствие связи по указанному адресу",
          value: "Отказ-Отсутствие связи по указанному адресу",
        }
      ]

      this.items.push(...testItems);
    }

    this.resetForm();
  },

  methods: {
    ...mapActions("app", ["appRestart"]),

    resetForm() {
      this.restartAgree = false;
      this.stopReason = undefined;
      this.selectedOptions = Object.assign({}, defaultSelectedOptions);

      // после обновления формы ни один документ не выбран - выбираем все по-умолчанию
      this.onChangeAttachmentsMeetingClean(this.selectedOptions['ATTACHMENTS_APP_CLEAN']);
    },

    onChangeAttachmentsMeetingClean(value) {
      if (value === true && this.attachmentsDocuments) {
        this.selectedOptions['ATTACHMENTS_TYPES_APP_CLEAN'] = Array.from(this.attachmentsDocuments.keys());
      } else {
        this.selectedOptions['ATTACHMENTS_TYPES_APP_CLEAN'] = null;
      }
    },

    onChangeAttachmentsTypesMeetingClean(types) {
      if (!types?.length) {
        this.selectedOptions['ATTACHMENTS_APP_CLEAN'] = false;
      }
    },

    async restart() {
      const res = this.appRestart({
        stop_reason: this.stopReason,
        options: Object.keys(this.selectedOptions),
        selected_options: this.selectedOptions
      });

      if (res) {
        this.resetForm();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-input--checkbox .v-label {
  font-size: 0.9em;
}
</style>
